module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAUCAMAAABYi/ZGAAAAclBMVEUAAACqqqqrq6urq6uqqqqqqqqrq6urq6upqamqqqqrq6urq6usrKyrq6uqqqqqqqqqqqqqqqqqqqqxsbGqqqqrq6upqamtra2qqqqqqqqqqqqqqqqrq6uqqqqqqqqqqqqrq6u/v7+xsbGqqqqqqqqurq5azY6DAAAAJnRSTlMAxYlNgdFsW7+QjXVBKdWWemAzDNyFaDfjzMmdcVPwtkYIBq6qJpfW0/UAAAC7SURBVBjTdY5HEoMwDEUldwwYiIHQS8r9rxiZsoCZvI3/fyPLBuJR4kmZwk4i4IQ9/zrvL857gEJKRi7VWn/JMek01HFs24yjqlXHM2mHvIBaa4siCnsSW3V2LIowNyjVp+FPkVJxmOukdPMn2917dq000DAiP5wIpYTEcc6Xwy2UXQIgEdHkObkqRqKlhECsEU5oXxD66bQxkzHjxVUVbWLi4lYlGqGud4mSA9wd+pu7nf2WNDZIz279ByhfCWfKDUs/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/proyectos.png
// module id = 529
// module chunks = 0